import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { catchError, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(
    private _http: HttpClient,
  ) { }

  /**
   * `incluir_compartidas=true`: la web nueva sabe manejar las tandas que otro
   * organizador le compartió (co-organizador). Vienen con `rol`; un back
   * viejo ignora el parámetro. Las apps ya publicadas no lo mandan.
   */
  public getDashboard(): Observable<unknown> {
    return this._http.get<{data: unknown}>(`${environment.apiUrl}/dashboard`, { params: { incluir_compartidas: 'true' } })
    .pipe(
      map(res => res.data),
      catchError((err) => {
        throw err;
      })
    );
  }

  /**
   * Salud de cada tanda del organizador, ya calculada por el back.
   *
   * Es nuevo: un back que todavia no lo tiene contesta 404, y quien llama
   * cae al calculo aproximado con `getDashboard()` + la bandeja. Por eso aqui
   * no se atrapa el error.
   */
  public getOrganizerOverview(): Observable<unknown> {
    return this._http.get<{data: unknown}>(`${environment.apiUrl}/dashboard/organizer-overview`, { params: { incluir_compartidas: 'true' } })
    .pipe(map(res => res.data));
  }

  public getMyParticipations(): Observable<unknown> {
    return this._http.get<{data: unknown}>(`${environment.apiUrl}/dashboard/my-participations`)
    .pipe(
      map(res => res.data),
      catchError((err) => {
        throw err;
      })
    );
  }

}
